import React, { useEffect, useState, useCallback } from "react";
import { getAssignmentByUserId } from "../../../services/operations/assignmentAPI";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AssignmentSection = ({ user }) => {
  const { t } = useTranslation();
  const [detail, setDetail] = useState([]);
  const location = useLocation();

  // Determine if the URL contains "/dashboard/teacher/student-progress"
  const isTeacherProgress = location.pathname.includes(
    "/dashboard/teacher/student-progress"
  );

  // Select ID based on route
  const id = isTeacherProgress ? user?.children?.[0] : user?._id;

  const fetchAssignment = useCallback(async () => {
    if (!id) return;
    const data = await getAssignmentByUserId(id)();
    const assignmentData = data?.data;

    if (assignmentData) {
      setDetail(assignmentData);
    }
  }, [id]);

  useEffect(() => {
    fetchAssignment();
  }, [fetchAssignment]);

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-3">{t("assignments.title")}</h2>

      {/* No Assignments */}
      {detail.length === 0 && (
        <p className="text-gray-500">{t("assignments.noAssignments")}</p>
      )}

      {/* Assignment Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {detail.map((item, index) => (
          <div key={index} className="border rounded-lg p-4 shadow-sm bg-white">
            <h3 className="text-lg font-semibold mb-2">
              {t("assignments.assignmentNumber", { number: index + 1 })}
            </h3>

            {/* Status */}
            <p className="mb-1">
              <span className="font-semibold">{t("assignments.status")}: </span>
              <span
                className={`${
                  item.status === "completed"
                    ? "text-green-600"
                    : "text-yellow-600"
                } font-medium`}
              >
                {t(`assignments.statusValues.${item.status}`) || "N/A"}
              </span>
            </p>

            {/* Marks (only if completed) */}
            {item.status === "completed" && (
              <p className="mb-1">
                <span className="font-semibold">{t("assignments.marks")}:</span>{" "}
                {item.marks ?? "N/A"} {t("assignments.outOf", { total: 5 })}
              </p>
            )}

            {/* English/Telugu Summary */}
            <p className="mt-2">
              <span className="font-semibold">{t("assignments.summary")}:</span>
              <br />
              <span className="text-gray-700 text-sm">
                {item?.english_version?.summary || item?.telugu_version?.summary || t("assignments.noSummary")}
              </span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignmentSection;
